module.exports = __webpack_public_path__ + "static/img/geren19.82d6c7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gerenzhongxin/geren19.png
// module id = 1Dzo
// module chunks = 2